'use client';

import { useEffect } from 'react';
import { usePathname, useSearchParams } from 'next/navigation';

const ScrollToHash = () => {
  const pathname = usePathname();
  const searchParams = useSearchParams();

  useEffect(() => {
    const hash = window.location.hash;

    if (hash) {
      const id = hash.substring(1);

      const _scrollToTarget = (initScroll) => {
        const element = document.getElementById(id);
        if (element) {
          element.scrollIntoView({
            behavior: 'smooth',
            block: 'start',
          });
        } else if (initScroll) {
          // Edge issue: many sections don't load until the user interacts (e.g., scroll).
          // To work around this, we trigger a small scroll to force all sections to render on first load.
          window.scrollTo({
            top: 50,
            behavior: 'smooth',
          });
        }
      };

      setTimeout(() => {
        _scrollToTarget(true);
        /**
         * Complex pages like PDP may need more time to render.
         * Scroll again if content isn't fully loaded.
         */
        setTimeout(() => {
          _scrollToTarget();
        }, 500);
      }, 1000);
    }
  }, [pathname, searchParams]);

  return null; // This component doesn't render anything
};

export default ScrollToHash;
